import { render } from "./Social.vue?vue&type=template&id=640e6e04"
import script from "./Social.vue?vue&type=script&lang=js"
export * from "./Social.vue?vue&type=script&lang=js"

import "./Social.vue?vue&type=style&index=0&id=640e6e04&lang=scss"
script.render = render

export default script